import { render, staticRenderFns } from "./HomeTable.vue?vue&type=template&id=680b4d33&"
import script from "./HomeTable.vue?vue&type=script&lang=js&"
export * from "./HomeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports